import { t } from '../../libs/translationsUtils/translations'

export const toEditorFormat = content => {
  if (!content) return content

  let el = document.createElement('div')
  el.innerHTML = content

  const BBCodeCodeBlocks = el.querySelectorAll('.threadCode')
  BBCodeCodeBlocks.forEach((BBCodeCodeBlock) => {
    const oldCode = BBCodeCodeBlock.getElementsByTagName('pre')[0]
    const newCode = document.createElement('code')
    newCode.innerHTML = oldCode.innerHTML
    oldCode.innerHTML = newCode.outerHTML
    BBCodeCodeBlock.replaceWith(newCode)
  })

  const codeBlocks = el.querySelectorAll('code')
  codeBlocks.forEach((codeBlock) => {
    codeBlock.innerHTML = codeBlock.innerHTML.replace(/(<br>)/gm, '\n')
  })

  const callouts = el.querySelectorAll('.callout')
  callouts.forEach((callout) => {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = callout.innerHTML
    callout.innerHTML = wrapper.outerHTML
  })

  const spoilerContainersConverted = el.querySelectorAll('content-spoiler')

  if (spoilerContainersConverted.length) {
    spoilerContainersConverted.forEach(spoilerContainerConverted => {
      const spoilerContainer = document.createElement('div')
      spoilerContainer.classList.add('spoiler-container')

      spoilerContainer.innerHTML = `<div class='hideBtn'>Hide content</div><div class='content-spoiler'>${spoilerContainerConverted.innerHTML}</div>`
      spoilerContainerConverted.replaceWith(spoilerContainer)
    })
  }

  const quotes = el.querySelectorAll('content-quote')
  quotes.forEach((quote) => {
    let quotedUser = document.createElement('div')
    quotedUser.className = 'content-quote-username'
    quotedUser.innerHTML = `${quote.getAttribute('data-username')} ${t('Common', 'wrote')}:`

    quote.insertAdjacentElement('afterbegin', quotedUser)
  })

  return el.innerHTML
}

export const fromEditorFormat = content => {
  if (!content) return content

  let el = document.createElement('div')
  el.innerHTML = content
  const embeds = el.querySelectorAll('[data-oembed-url]')
  embeds.forEach(embed => {
    let embedNode = document.createElement('oembed')
    embedNode.setAttribute('url', embed.getAttribute('data-oembed-url'))
    embed.replaceWith(embedNode)
  })

  let codeBlocks = el.querySelectorAll('code')
  let store = []
  codeBlocks.forEach(codeBlock => {
    store.push(codeBlock)
  })

  el.innerHTML = el.innerHTML.replace(/(\r\n|\n|\r)/gm, '')

  codeBlocks = el.querySelectorAll('code')

  codeBlocks.forEach((codeBlock, index) => {
    store[index].innerHTML = store[index].innerHTML.replace(/(\r\n|\n|\r)/gm, '<br>')
    codeBlock.replaceWith(store[index])
  })

  const spoilerContainers = el.querySelectorAll('.spoiler-container')
  const contentSpoilers = el.querySelectorAll('.content-spoiler')

  if (spoilerContainers.length) {
    spoilerContainers.forEach((spoilerContainer, i) => {
      let spoilerEl = document.createElement('content-spoiler')
      spoilerEl.innerHTML = contentSpoilers[i].innerHTML
      spoilerContainer.before(spoilerEl)
      spoilerContainer.remove()
    })
  }

  // remove captions if empty
  const figureCaptions = el.querySelectorAll('figcaption')
  figureCaptions.forEach(caption => {
    if (!caption.textContent.trim()) {
      caption.remove()
    }
  })

  const quoteUsers = el.querySelectorAll('.content-quote-username')
  quoteUsers.forEach(quote => {
    quote.remove()
  })
  return el.innerHTML
}
